import React from "react";
import { useDispatch } from "react-redux";

import { Blade, Button } from "rhombus-react";

import { closeModal } from "reducers/Modal";
import { exportVersions } from "reducers/Export";

import "./ConfirmBulkExport.css";

export default function ConfirmBulkExport({ creativeIds = []}) {
	const dispatch = useDispatch();

	function onClose() {
		dispatch(closeModal());
	}

	function onConfirm() {
		dispatch(exportVersions(false, ...creativeIds));
		onClose();
	}

	function renderContent() {
		return (
			<div className="confirm-bulk-export-versions-body">
				<p>
					One or more of the selected creatives have version variable
					keys that do not match. If you proceed with the export each
					creative will have a separate tab in the spreadsheet.
				</p>
				<p>Are you sure you wish to continue?</p>
			</div>
		);
	}

	function renderFooter() {
		return (
			<>
				<Button theme="default" onClick={onClose}>
					Cancel
				</Button>
				<Button theme="green" onClick={onConfirm}>Export</Button>
			</>
		);
	}

	return (
		<Blade
			type="modal"
			title="Confirm Export Versions"
			className="confirm-bulk-export-versions"
			allowFullScreen={false}
			bladeProps={{ verticallyCenter: true }}
			xClose
			onClose={onClose}
			renderContent={renderContent}
			renderFooter={renderFooter}
			setAppTitle={false}
		/>
	);
}
